import { trackGtmEvent } from '@src/scripts/lib/gtm';

let count = 0;
globalThis.document.addEventListener(
	'find-your-study-results-changed',
	( e: CustomEvent ) => {
		count++;
		// ignore initial events
		if ( count < 3 ) {
			return;
		}
		const { filters, options, totalProducts } = e.detail;

		const sfStandorte =
			filters.sf_standorte && options.sf_standorte
				? filters.sf_standorte.map(
						( kurz: string ) =>
							options.sf_standorte.find(
								( { value }: { value: string } ) =>
									value === kurz
							).label
				  )
				: [];

		const themenschwerpunkte =
			options.sf_themenschwerpunkt_kurz &&
			filters.sf_themenschwerpunkt_kurz
				? filters.sf_themenschwerpunkt_kurz.map(
						( kurz: string ) =>
							options.sf_themenschwerpunkt_kurz.find(
								( { value }: { value: string } ) =>
									value === kurz
							)?.label || ''
				  )
				: filters.sf_themenschwerpunkt;

		const join = ( xs?: Array< any > ) =>
			( xs || [] ).join( ',' ) || undefined;

		trackGtmEvent(
			'ga_event',
			{
				category: 'filter_usage',
				filter_study_format: join( filters.sf_studiengangsform ),
				filter_graduation_level: join( filters.sf_abschlussart ),
				filter_study_topic: join( themenschwerpunkte ),
				filter_study_location: join( sfStandorte ),
				filter_study_language: join( filters.sf_sprache ),
				filter_search_term: join( filters.keywords ),
				filter_results: totalProducts,
			},
			true
		);
	}
);
